export default [
  {
    name: 'Vigente',
    id: 1,
    default_name: 'current_contracts',
  },
  {
    name: 'Rascunho',
    id: 2,
    default_name: 'draft_contracts',
  },
];



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/freight-quote/enums/EnumContractStatus.js